import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import useLoyaltyPointsEarnCalculator from 'loyalty/hooks/useLoyaltyPointsEarnCalculator'
import determineLoyaltyBonusPointsCampaignType from 'loyalty/lib/determineLoyaltyBonusPointsCampaignType'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import React from 'react'
import LoyaltyBonusPointsInfoSheet from './Banners/LoyaltyBonusPointsInfoSheet'

interface Props {
  calculationRequests?: Array<App.LoyaltyPointsEarnCalculationRequest | undefined> | App.LoyaltyPointsEarnCalculationRequest | undefined
}

function LoyaltyGenericInfoModal({ calculationRequests }: Props) {
  const programDisplayName = getLoyaltyProgramDisplayName()
  const { totalPointsCalculation } = useLoyaltyPointsEarnCalculator(calculationRequests)
  const bonusPointsCampaignType = totalPointsCalculation.data ? determineLoyaltyBonusPointsCampaignType(totalPointsCalculation.data) : undefined

  return <Modal
    title="Earning points & status credits"
    subtitle={<>As a member of {programDisplayName}, you&rsquo;ll earn points and status credits on every booking.</>}
    secondaryActionText="Find out more"
    secondaryActionTo={`/${LOYALTY_LANDING_PAGE}`}
    secondaryActionTarget="_blank"
  >
    <Group gap={16} direction="vertical">
      <div>
        <BodyText variant="large" weight="bold">
          {programDisplayName} Points
        </BodyText>
        <BodyText variant="large">
          Earn and redeem points on hotels, tours, flights, cruises and more.
        </BodyText>
      </div>
      <div>
        <BodyText variant="large" weight="bold">
          {programDisplayName} Status Credits
        </BodyText>
        <BodyText variant="large">
          Collect status credits on every booking to move up tiers and unlock rewards including room upgrades, airport transfers, lounge passes and more.
        </BodyText>
      </div>
      {!!bonusPointsCampaignType && <LoyaltyBonusPointsInfoSheet campaignType={bonusPointsCampaignType} />}
    </Group>
  </Modal>
}

export default LoyaltyGenericInfoModal
